import HeaderScrolled from '../../helper/header-scrolled';
import ScrollTo from '../../helper/scroll-to';
import IsotopeJS from './isotope-filter';
// import MasonryJS from './masonry';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

const GaleriPage = {
  init() {
    this._scrollToInit();
    this._headerScrolledInit();
    this._isotopeJS();
    // this._masonryJS();
  },


  _scrollToInit() {
    ScrollTo.init();
  },

  _headerScrolledInit() {
    HeaderScrolled.init();
  },


  _isotopeJS() {
    IsotopeJS.init();
  },


  _masonryJS() {
    MasonryJS.init();
  }
};

export default GaleriPage;